import { SocialLinksFilterProvider } from '@contexts/social-media-links/SocialLinksProvider';
import { Box } from '@mui/material';
import SocialMediaList from 'src/features/SocialMediaLinks/components/social-media-list';
import SocialUserInfo from 'src/features/SocialMediaLinks/components/social-user-info';
import './index.css';

const SocialMedia = () => {
  return (
    <Box className="social-media-container">
      <SocialUserInfo />
      <SocialLinksFilterProvider>
        <SocialMediaList />
      </SocialLinksFilterProvider>
    </Box>
  );
};

export default SocialMedia;
